import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { TRootState } from '@/redux/rootReducer';
import {
  getCampgroundGallery,
  getGallery,
  getRVBundleGallery,
} from '@/redux/selectors/listing/gallery';
import { EImageTags, IImage } from '@/services/types/search/rentals/id';

import GalleryList from './GalleryList';

type TFilterSlides = TRootState['filterSlides'];
interface IGalleryListContainerProps {
  isCampground?: boolean;
  isRVBundle?: boolean;
}
const GalleryListContainer = ({ isCampground, isRVBundle }: IGalleryListContainerProps) => {
  const images: IImage[] = useSelector(
    isRVBundle ? getRVBundleGallery : isCampground ? getCampgroundGallery : getGallery,
  );
  const [sortedImages, setSortedImages] = useState(images);
  const filterSlides = useSelector<TRootState, TFilterSlides>(state => state.filterSlides);

  useEffect(() => {
    const category = filterSlides?.category;
    let newSortedImages: IImage[];

    if (category === EImageTags.ALL || !category) {
      newSortedImages = images;
    } else {
      if (category === EImageTags.VIDEO) {
        newSortedImages = images.filter(image => image.video);
      } else {
        newSortedImages = images.filter(image => image.category?.slug === category && !image.video);
      }
    }

    setSortedImages(newSortedImages);
  }, [filterSlides?.category, images]);

  return <GalleryList images={sortedImages} />;
};

export default GalleryListContainer;
